module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Gross/Net Pension Calculator",
      "icon": "pension"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Fiscal Year"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fiscalYear),
      expression: "fiscalYear"
    }],
    ref: "fiscalYear",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fiscalYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("2019/20")]), _vm._v(" "), _c('option', [_vm._v("2018/19")]), _vm._v(" "), _c('option', [_vm._v("2017/18")]), _vm._v(" "), _c('option', [_vm._v("2016/17")]), _vm._v(" "), _c('option', [_vm._v("2015/16")]), _vm._v(" "), _c('option', [_vm._v("2014/15")]), _vm._v(" "), _c('option', [_vm._v("2013/14")]), _vm._v(" "), _c('option', [_vm._v("2012/13")]), _vm._v(" "), _c('option', [_vm._v("2011/12")]), _vm._v(" "), _c('option', [_vm._v("2010/11")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Net or Gross"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pensionType),
      expression: "pensionType"
    }],
    ref: "pensionType",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pensionType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Gross")]), _vm._v(" "), _c('option', [_vm._v("Net")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Pension Income",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.income),
      expression: "income",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "income",
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.income)
    },
    on: {
      "focus": function($event) {
        _vm.income = _vm.income || ''
      },
      "blur": [function($event) {
        _vm.income = _vm.income || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.income = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('h2', [_vm._v("\n                    Result\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Gross Income",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pension.results.grossIncome),
      expression: "pension.results.grossIncome",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.pension.results.grossIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pension.results, "grossIncome", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Net Income",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pension.results.netIncome),
      expression: "pension.results.netIncome",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.pension.results.netIncome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pension.results, "netIncome", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Income Tax Paid",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pension.results.taxPaid),
      expression: "pension.results.taxPaid",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.pension.results.taxPaid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pension.results, "taxPaid", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResults),
      expression: "showResults"
    }],
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                With a gross pension income of £" + _vm._s(_vm.twoDp(_vm.pension.results.grossIncome || 0)) + ", for the fiscal year of " + _vm._s(_vm.fiscalYear) + ",\n                £" + _vm._s(_vm.twoDp(_vm.pension.results.taxPaid || 0)) + " of income tax would be paid. The breakdown for this calculation is outlined \n                further down this page, noting the personal allowance and tax brackets for the fiscal year selected.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                This results in a Net pension income of £" + _vm._s(_vm.twoDp(_vm.pension.results.netIncome || 0)) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The following chart provides a visual indication of income tax paid on the gross pension:"), _c('br')]), _vm._v(" "), (_vm.pension.results.grossIncome) ? _c('div', {
    staticClass: "chart"
  }, [_c('pie-chart', {
    attrs: {
      "chart-data": _vm.chartData,
      "options": _vm.chartOptions
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c990db64!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/pension.vue
// module id = 1806
// module chunks = 0